// extracted by mini-css-extract-plugin
module.exports = {"icon":"_7a3fb80146--icon--Vicf_"};